export const setCollapsedAppMenu = value => {
    localStorage.setItem('isCollapsedAppMenu', value)
}
export const getCollapsedAppMenu = () => {
    return localStorage.getItem('isCollapsedAppMenu') &&
        localStorage.getItem('isCollapsedAppMenu') !== 'undefine'
        ? JSON.parse(localStorage.getItem('isCollapsedAppMenu'))
        : false
}

export const setMobileAppMenuActive = value => {
    localStorage.setItem('mobileMenuActive', value)
}
export const getMobileAppMenuActive = () => {
    return localStorage.getItem('mobileMenuActive') &&
        localStorage.getItem('mobileMenuActive') !== 'undefine'
        ? JSON.parse(localStorage.getItem('mobileMenuActive'))
        : false
}
